module.exports = __webpack_public_path__ + "static/img/mt_download_use_case_1.16545cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/mt_download_use_case_1.png
// module id = 349
// module chunks = 2